import React from 'react';
import Slider from 'react-slick';
import './ImageCarousel.css';

export const ImageCarousel = () => {
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    dots: true,
    centerPadding: '0px',
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 4000,
    cssEase: 'linear',
  };

  const imageCount = 5;
  const images = Array.from(
    { length: imageCount },
    (_, i) => `/images/galleryCarousel/carousel_${i + 1}.jpg`
  );

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {images.map((src, index) => (
          <div key={index}>
            <img
              src={src}
              alt={`Carousel ${index + 1}`}
              className="carousel-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};
